import { Alert, getAlertCompType, getAlertTypeLabel } from '@aloft/toolkit-shared';

import { getAlertToastId } from './constants.ts';
import { dismissInactiveAlertToasts, isAlertToastRegistered } from './dismissAllToasts.ts';
import { MakeToast } from './types.ts';

export const applyVisibleAlertToasts = (
  visibleAlerts: ReadonlyArray<Alert>,
  makeToast: MakeToast,
) => {
  dismissInactiveAlertToasts(new Set(visibleAlerts.map((alert) => alert.type)));

  visibleAlerts.forEach((alert) => {
    if (isAlertToastRegistered(alert.type)) {
      return;
    }
    makeToast({
      id: getAlertToastId(alert.type),
      alertType: alert.type,
      alertPropertyID: alert.propertyID,
      type: alert.severity,
      title: getAlertTypeLabel(alert.type),
      body: alert.message,
      compType: getAlertCompType(alert),
      comparablesAlerts: true,
      openAlertsOnClick: true,
    });
  });
};
